import { atom } from "recoil"

import { DateTimePickerConfig } from "../../types"

export const dateTimePickerVisibilityState = atom({
  key: "dateTimePickerVisibility",
  default: false,
})

export const dateTimePickerConfigState = atom({
  key: "dateTimePickerConfig",
  default: undefined as DateTimePickerConfig | undefined,
})
